import React from "react";
import { Navigate } from "react-router-dom";
import useTokenRefresh from "../hooks/useTokenRefresh";
import useConfigRefresh from "../hooks/useConfigRefresh";

// Separate component to handle background tasks (only renders when authenticated)
const AuthenticatedWrapper = ({ children }) => {
  // Automatically refresh tokens every 5 minutes to keep session alive
  useTokenRefresh(5);

  // Automatically refresh config/reference data every 60 minutes
  // This ensures dropdown data is always available and up-to-date across all screens
  useConfigRefresh(60);

  return children;
};

const CheckAuth = ({ isAuth, children }) => {
  if (isAuth) {
    return <AuthenticatedWrapper>{children}</AuthenticatedWrapper>;
  } else {
    return <Navigate to="/login" />;
  }
};

export default CheckAuth;
